var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSchloss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "84.925px",
    height: "113.103px",
    viewBox: "0 0 84.925 113.103",
    enableBackground: "new 0 0 84.925 113.103",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3F8EF2",
    d: "M73.387,101.625H11.436V45.764h62.052L73.387,101.625z M42.535,11.414 c11.721,0.023,21.214,9.525,21.227,21.247v1.646H21.391v-1.646C21.402,20.972,30.845,11.482,42.535,11.414 M75.176,34.327v-1.645 C75.175,14.631,60.542,0,42.492,0C24.443,0.001,9.812,14.632,9.811,32.683v1.645H0v78.775h84.925V34.327H75.176z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F8EF2",
    d: "M36.755,74.188v14.398h11.437V74.188c4.445-3.157,5.488-9.32,2.33-13.766s-9.321-5.488-13.767-2.33 c-4.445,3.157-5.488,9.321-2.33,13.767C35.065,72.759,35.853,73.547,36.755,74.188"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchloss);
export default __webpack_public_path__ + "static/media/schloss.33b496659035b74db33c9e4e0e9e7142.svg";
export { ForwardRef as ReactComponent };